import { PlayerPhotos } from '@/entities';
import { determinePlayerPhotoForPlayerMovesUrl } from '@/lib/helper';
import { Avatar, Checkbox } from '@pickleballinc/react-ui';
import { Icon } from '@pickleballinc/ui/components/ui/icon';

import { useQueryState } from 'nuqs';

interface PlayerCardProps {
	name: string;
	phone: string;
	duprDoubles: number;
	duprSingles: number;
	image: PlayerPhotos | undefined;
	onCheck?: (e: boolean) => void;
	isPlaceholder?: boolean;
	position?: number;
	isInvited?: boolean;
	isNewPlayer?: boolean;
	onRemove?: () => void;
	isChecked?: boolean;
}

export default function PlayerCard({
	name,
	phone,
	duprDoubles,
	duprSingles,
	image,
	onCheck,
	isPlaceholder,
	position,
	isInvited,
	isNewPlayer,
	onRemove,
	isChecked
}: PlayerCardProps) {
	const [, setAdd] = useQueryState('add');

	if (isPlaceholder) {
		return (
			<div className="relative flex h-[150px] min-w-[160px] flex-col items-center gap-2 rounded-lg border border-darkorange-400 bg-violet-25 p-2 shadow-lg">
				<Avatar size="md" imageUrl={undefined} />
				<p className="text-black font-semibold">{`Player ${position ? position + 1 : ''}`}</p>
				<button
					onClick={() => setAdd('true')}
					className="mt-auto w-full rounded-md bg-darkorange-100 px-3 py-1 text-sm font-medium text-darkorange-600 hover:bg-darkorange-200"
				>
					Add
				</button>
			</div>
		);
	}

	return (
		<div className="flex flex-col justify-end">
			{(isNewPlayer || isInvited) && (
				<div className="mb-[-1px] z-10 self-start rounded-t-md bg-violet-25 px-2 py-[2px] border-t border-l border-r border-darkorange-300">
					<span className="text-xs font-medium text-green-700 leading-none block">{isNewPlayer ? 'New!' : 'Invited'}</span>
				</div>
			)}
			<div
				className={`relative flex h-[150px] min-w-[160px] flex-col items-center gap-2 border border-darkorange-300 bg-violet-25 p-2 shadow-lg ${
					isNewPlayer || isInvited ? 'rounded-bl-lg rounded-r-lg' : 'rounded-lg'
				}`}
			>
				{onCheck && (
					<Checkbox
						theme="orange"
						{...(isChecked !== undefined ? { checked: isChecked } : {})}
						onChange={(e: any) => {
							onCheck(e.target.checked);
						}}
						className="absolute right-2 top-2"
					/>
				)}
				{onRemove && <Icon onClick={onRemove} className="absolute right-2 top-2 cursor-pointer" glyph="trash-can" />}
				<Avatar size="md" imageUrl={determinePlayerPhotoForPlayerMovesUrl(image)} />
				<p className="font-semibold text-gray-900">{name}</p>
				<p className="text-xs text-gray-400">{phone}</p>
				<div className="flex gap-2 text-xs text-black">
					<p>(D) {duprDoubles ? duprDoubles.toFixed(2) : 'NR'}</p>
					<p>(S) {duprSingles ? duprSingles.toFixed(2) : 'NR'}</p>
				</div>
			</div>
		</div>
	);
}
